<template>
    <static-foundation-page-content class="newsletter-subscription-verification-success">
        <p>{{$tc('newsletter.pages.verification.text')}}</p>
    </static-foundation-page-content>
</template>
<script>
import StaticFoundationPageContent from '@/components/foundation/StaticFoundationPageContent';

export default {
    name: 'NewsletterSubscriptionVerificationSuccess',
    components: {
        StaticFoundationPageContent
    },
    activated() {
        this.$store.commit('navigation/setPageRoot', {
            title: this.$tc('newsletter.pages.verification.heading'),
            path: null
        });
    },
}
</script>
